module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/courtney-reiff-0d9fc59dc18f43d84b44c6cbd737e762.jpg";